import React, { useEffect, useState } from 'react'
import {
  Panel,
  Row,
  Col,
  Input,
  SelectPicker,
  Checkbox,
  RadioGroup,
  Radio,
  Uploader,
  ControlLabel,
  Message,
  Icon,
  IconButton,
  Table,
  ButtonGroup,
  Whisper,
  Tooltip,
  CheckboxGroup,
} from 'rsuite'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import InputForm from '../../../components/forms/input/InputForm'
import { isImageOrPdf, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import { isEmpty, values } from 'lodash-es'
import notification from '../../../utils/notification'
import { getValueFromOptions } from '../../../utils/dataUtil'
import CKEditorBlankFrom from '../../../components/forms/input/CKEditorBlankFrom'
import IncomeRecordFileTable from '../../incomeRecordWidget/IncomeRecordFileTable'
import { downloadAuditfilesAttachments } from '../../../redux/actions/reportsAudit'
import { doneLoading, startLoading } from '../../../utils/loading'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import { callInfomaDownloadService } from '../../attachfiles/AttachFilesViewDownload'
import moment from 'moment'
import { DD_MM_YYYY_SLASH } from '../../../constants/date'

export default function DirectorFollowAuditIssuesForm({
  schema: _schema,
  loading,
  register,
  Controller,
  control,
  errors,
  getValues,
  setValue,
  clearErrors,
  isViewMode,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [projectGrade, setProjectGrade] = useState()
  const [auditResults, setAuditResults] = useState()
  const [formSchema, setFormSchema] = useState(_schema)
  const [checkRadio, setCheckRadio] = useState(null)
  const [fileTypeError, setFileTypeError] = useState(false)
  // const [otherAttach, setOtherAttach] = useState(_schema?.attachFiles || [])
  const [fileTableData, setFileTableData] = useState(_schema?.issueForm?.attachFiles?.value || [])
  const [checkRadioDirector, setCheckRadioDirector] = useState(null)
  const [otherAttach, setOtherAttach] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [auditBudgetValues, setAuditBudgetValues] = useState(_)

  useEffect(() => {
    // console.log('formSchema => ', formSchema)
    if (formSchema?.attachFiles?.values && formSchema?.attachFiles?.values.length > 0) {
      setOtherAttach(formSchema?.attachFiles?.values)
    }
    setCheckRadioDirector(formSchema.approveOption?.value)

    if (!formSchema?.coordinatorOption.value || formSchema?.coordinatorOption.value?.length === 0) {
      setValue(formSchema?.coordinatorOption.name, undefined)
      register(formSchema?.coordinatorOption.name, undefined)
      setCheckRadio([])
    } else {
      setCheckRadio(formSchema?.coordinatorOption?.value || [])
      register(formSchema?.coordinatorOption.name)
      setValue(formSchema?.coordinatorOption.name, [...formSchema?.coordinatorOption?.value])
    }
  }, [formSchema])

  useEffect(() => {
    setAuditBudgetValues(_schema?.auditBudget?.values || [])
  }, [_schema?.auditBudget?.values])

  const headerStyle = {
    // textAlign: 'center',
    // border: '1px solid #d3caca',
    // backgroundColor: '#e4e5e7',
    textAlign: 'center',
    borderBottom: '1px solid #d3caca',
    borderTop: '1px solid #d3caca',
    backgroundColor: '#e4e5e7',
    padding: 0,
  }

  const rowStyle = {
    marginTop: 10,
    border: '1px solid #d3caca',
    borderTop: 'none',
  }

  const leftColStyle = {
    borderRight: '1px solid #d3caca',
    padding: 0,
  }

  const rightColStyle = {
    borderLeft: '1px solid #d3caca',
    padding: 0,
  }

  let ResultsColor = ' '
  switch (formSchema?.auditorOption?.value) {
    case 1:
      ResultsColor = '#70b144'
      break
    case 2:
      ResultsColor = '#ffbd09'
      break
    case 3:
      ResultsColor = '#fb0403'
      break

    default:
      break
  }

  const onDownload = async (fileObj) => {
    startLoading()
    setIsLoading(true)
    try {
      var file = await downloadAuditfilesAttachments(fileObj.path)
      var fileName = fileObj.label

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    console.log('file => ', fileObj)
    startLoading()
    setIsLoading(true)
    try {
      var file = await downloadAuditfilesAttachments(fileObj.path)
      var fileName = fileObj.label

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'แสดง ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onPreviewInfoma = async () => {
    const fileObj = formSchema?.auditBook?.value.find(
      (e) => e.name.indexOf('06') != -1 && e.path != ''
    )

    console.log('fileObj => ', fileObj)
    if (fileObj) {
      let error = await callInfomaDownloadService(projectInfo.id, fileObj, 'preview')

      error ? setIsError('แสดง') : setIsError()
    } else {
      setIsError('แสดง')
    }
  }

  const onDownloadInfoma = async () => {
    const fileObj = formSchema?.auditBook?.value.find(
      (e) => e.name.indexOf('06') != -1 && e.path != ''
    )

    if (fileObj) {
      let error = await callInfomaDownloadService(projectInfo.id, fileObj, 'download')

      error ? setIsError('ดาวน์โหลด') : setIsError()
    } else {
      setIsError('ดาวน์โหลด')
    }
  }

  const generateRiskBlockNew = (
    riskSchema,
    risk,
    questionid,
    issueListIndex,
    issuesIndex,
    riskIndex
  ) => {
    var id = questionid + '_' + risk.id + '_'
    //example id = F01_8bca6305-6659-4b37-8354-1658dd5082d0_issuesDetected
    // console.log('id', id)
    // console.log('risk.id', risk.id)
    // console.log('risk===>', risk)
    // console.log('riskSchema===>', riskSchema)
    let color = ''
    switch (risk.trackingResults) {
      case 1:
        color = '#2da888'
        break
      case 2:
        color = '#f17e23'
        break
      case 3:
        color = '#575757'
        break
      case 4:
        color = '#ff0000'
        break
      case 99:
        color = '#fcee9e'
        break

      default:
        break
    }
    return (
      <Panel key={id} bordered style={{ marginTop: 10 }}>
        <Row style={{ marginTop: 10 }}>
          <Col lg={8} md={8} sm={24} xs={24}>
            <Col lg={20} md={20} sm={24} xs={24}>
              <p>{`ระดับความเสี่ยง : ${getValueFromOptions(
                riskSchema?.risk?.options,
                risk.risk
              )}`}</p>
            </Col>
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Row style={rowStyle}>
            <Col lg={12} md={12} sm={24} xs={24} style={leftColStyle}>
              {/* header */}
              <p style={headerStyle}>{riskSchema?.issuesDetected?.label}</p>
              {/* inptBlock1 */}

              <div
                style={{ wordWrap: 'break-word', padding: 5 }}
                dangerouslySetInnerHTML={{
                  __html: risk?.issuesDetected,
                }}
              />
            </Col>

            <Col lg={12} md={12} sm={24} xs={24} style={rightColStyle}>
              {/* header */}
              <p style={headerStyle}>{riskSchema?.explanation?.label}</p>
              {/* inptBlock1 */}

              <div
                style={{ wordWrap: 'break-word', padding: 5 }}
                dangerouslySetInnerHTML={{
                  __html: risk?.explanation,
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col lg={24} md={24} sm={24} xs={24} style={{ padding: 0 }}>
              {/* header */}
              <p
                style={{
                  textAlign: 'center',
                  border: '1px solid #d3caca',
                  backgroundColor: '#e4e5e7',
                  padding: 0,
                  marginTop: 5,
                }}
              >
                {riskSchema?.trackingResults?.label}
              </p>
            </Col>
          </Row>
          <Row>
            {/* selectBlock */}
            <Col lg={24} md={24} sm={24} xs={24}>
              <div style={{ marginTop: 10 }}>
                {risk?.trackingResultsName && (
                  <>
                    <div style={{ fontWeight: 'bold', display: 'inline' }}>
                      ผลความคืบหน้า :{' '}
                      <Icon
                        icon="info-circle"
                        size="lg"
                        style={{ marginTop: 5, color: color }}
                      />{' '}
                    </div>
                    <div
                      style={{ wordWrap: 'break-word', marginTop: 5, display: 'inline' }}
                      dangerouslySetInnerHTML={{
                        __html: risk?.trackingResultsName,
                      }}
                    />
                  </>
                )}
              </div>
            </Col>
          </Row>

          <Row>
            <Col lg={24} md={24} sm={24} xs={24}>
              {/* inptBlock2 */}
              <div style={{ display: 'flex', marginTop: 10 }}>
                {risk?.trackingResultsDetail && <b>ความเห็นเพิ่มเติม : </b>}
                <div
                  style={{ wordWrap: 'break-word', marginLeft: 5 }}
                  dangerouslySetInnerHTML={{
                    __html: risk?.trackingResultsDetail,
                  }}
                />
              </div>
            </Col>
          </Row>
        </Row>
      </Panel>
    )
  }

  const panelInput = (item, issueListIndex, issuesIndex) => {
    // console.log('item==>', item)
    let issueFile = []
    if (item?.filePath) {
      issueFile.push({
        label: item?.fileName || '',
        path: item?.filePath || '',
      })
    }

    return (
      <>
        {item.risks?.map((risk, index) => {
          return (
            !risk?.isDeleted &&
            risk.id &&
            generateRiskBlockNew(
              _schema.issueForm,
              risk,
              item.issueCode,
              issueListIndex,
              issuesIndex,
              index
            )
          )
        })}

        <Row style={{ marginTop: 25 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            {formSchema.attachFiles?.label || 'เอกสารแนบประกอบ'} {' : '}
          </Col>
          <Col lg={20} md={20} sm={24} xs={24}>
            {item?.filePath && (
              <div>
                <IncomeRecordFileTable
                  data={issueFile}
                  deleteable={false}
                  onPreview={onPreview}
                  onDownload={onDownload}
                />
              </div>
            )}
          </Col>
        </Row>
      </>
    )
  }

  const generateAuditBudgetNew = (valuesIndex, valuesItem) => {
    return (
      <>
        <Row style={{ marginBottom: 10 }} key={valuesIndex}>
          <Col lg={1} md={1} sm={24} xs={24}>
            {`${valuesIndex + 1}.)`}
          </Col>
          <Col lg={3} md={3} sm={24} xs={24}>
            <ControlLabel>{formSchema.auditBudget.auditPeriod.label + ' : '}</ControlLabel>
            {valuesItem.auditPeriod || '0'}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ControlLabel>{formSchema.auditBudget.auditorCompany.label + ' : '}</ControlLabel>
            {valuesItem.auditorCompany || ''}
          </Col>
          <Col lg={6} md={6} sm={24} xs={24}>
            <ControlLabel>{formSchema.auditBudget.auditorName.label + ' : '}</ControlLabel>
            {valuesItem.auditorName || ''}
          </Col>
          <Col lg={6} md={6} sm={24} xs={24}>
            <ControlLabel>{formSchema.auditBudget.auditorLicenseNumber.label + ' : '}</ControlLabel>
            {valuesItem.auditorLicenseNumber || ''}
          </Col>
        </Row>
      </>
    )
  }

  return (
    <>
      <Panel header={' '} bordered collapsible defaultExpanded style={{ marginTop: 20 }}>
        <Panel bordered header={'รายงานตรวจสอบฉบับสมบูรณ์'}>
          <>
            {isError && (
              <Row style={{ marginBottom: 10 }}>
                <Message
                  showIcon
                  type="error"
                  description={`เกิดข้อผิดพลาดในการ${isError} กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ`}
                />
              </Row>
            )}
            <Row>
              <Col lg={8} md={8} sm={24} xs={24}>
                <b>กำกับ/ประเมินผล/ตรวจสอบ</b>
              </Col>
              <Col lg={16} md={16} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <ButtonGroup>
                  <Whisper
                    placement="top"
                    trigger="hover"
                    speaker={
                      <Tooltip>
                        คลิกเพื่อ <i>แสดงไฟล์</i>
                      </Tooltip>
                    }
                  >
                    <IconButton
                      appearance="ghost"
                      size="sm"
                      icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                      disabled={
                        !formSchema?.auditBook?.value.find(
                          (e) => e.name.indexOf('06') != -1 && e.path != ''
                        )
                      }
                      onClick={(e) => onPreviewInfoma()}
                    />
                  </Whisper>

                  <Whisper
                    placement="top"
                    trigger="hover"
                    speaker={
                      <Tooltip>
                        คลิกเพื่อ <i>ดาวน์โหลดไฟล์</i>
                      </Tooltip>
                    }
                  >
                    <IconButton
                      appearance="ghost"
                      size="sm"
                      icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                      disabled={
                        !formSchema?.auditBook?.value.find(
                          (e) => e.name.indexOf('06') != -1 && e.path != ''
                        )
                      }
                      onClick={(e) => onDownloadInfoma()}
                    />
                  </Whisper>
                </ButtonGroup>
              </Col>
            </Row>
          </>
        </Panel>
        <Panel>
          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {formSchema.auditByCompany.label}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {`  :  ${formSchema.auditByCompany.value || ''}`}
            </Col>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {formSchema.auditName.label}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {`  :  ${formSchema.auditName.value || ''}`}
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>{formSchema.auditPeriod.label}</ControlLabel>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {`  :  ${formSchema.auditPeriod.value || ''}`}
            </Col>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <ControlLabel>{formSchema.auditDate.label}</ControlLabel>
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {formSchema?.auditDate?.value
                ? ': ' +
                  moment(moment(formSchema?.auditDate?.value).toDate()).format(DD_MM_YYYY_SLASH)
                : ''}
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {formSchema.auditorLicenseNumber.label}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {`  :  ${formSchema.auditorLicenseNumber.value || ''}`}
            </Col>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {formSchema.auditBudgetYear.label}
            </Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {`  :  ${formSchema.auditBudgetYear.value || ''}`}
            </Col>
          </Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {`${formSchema.auditResults.label} :`}
            </Col>
            <Col lg={18} md={18} sm={24} xs={24}>
              <div>
                <Icon
                  icon="circle"
                  size="lg"
                  style={{ marginRight: 5, marginTop: 5, color: ResultsColor }}
                />
                {/* {` ${formSchema.auditorOption.valueDef || ''}`} */}
                <span
                  dangerouslySetInnerHTML={{
                    __html: formSchema?.auditorOption?.valueDef || '',
                  }}
                  style={{ marginLeft: 10, marginTop: 2 }}
                />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
              ตรวจสอบการใช้จ่ายเงินโดยบริษัท
            </Col>
            <Col lg={20} md={20} sm={24} xs={24}>
              <Panel bordered>
                {auditBudgetValues.map((item, index) => {
                  return generateAuditBudgetNew(index, item)
                })}
              </Panel>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>{formSchema.conclusion}</Row>

          <Row style={{ marginTop: 10 }}>
            <Col lg={18} md={18} sm={24} xs={24}>
              {formSchema.description.label}
              {`  :  ${formSchema.description.value || ''}`}
            </Col>

            <Col lg={6} md={6} sm={24} xs={24}>
              {formSchema.projectGrade.label}
              {`  :  ${
                getValueFromOptions(
                  formSchema.projectGrade.options,
                  formSchema.projectGrade.value
                ) || ''
              }`}
            </Col>
          </Row>
          <hr />
        </Panel>

        {formSchema?.issueList?.map((element, i) => {
          return (
            <Panel header={element.title} collapsible defaultExpanded key={i}>
              {element.issues?.map((item, index) => {
                return (
                  <Panel
                    key={index}
                    header={
                      <div style={{ color: 'black' }}>{item.issueCode + ' ' + item.issueName}</div>
                    }
                    collapsible
                    defaultExpanded={item?.risks?.length > 0 ? true : false}
                    // defaultExpanded
                    style={{ marginTop: -20 }}
                  >
                    {panelInput(item, i, index)}
                  </Panel>
                )
              })}
            </Panel>
          )
        })}

        {formSchema.otherDesc && (
          <Row style={{ marginTop: 10 }}>
            <Col lg={24} md={24} sm={24} xs={24}>
              {formSchema.otherDesc.label} :
            </Col>
            <Col lg={24} md={24} sm={24} xs={24}>
              <div style={{ marginLeft: 20 }}>{formSchema.otherDesc.value || ''}</div>
            </Col>
          </Row>
        )}

        <hr />
        <Row style={{ marginTop: 10 }}>
          <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                _schema.issueForm.attachFiles.validators,
                _schema.issueForm.attachFiles.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={18} md={18} sm={24} xs={24}>
            {otherAttach?.length > 0 && (
              <div>
                <IncomeRecordFileTable
                  data={otherAttach}
                  onPreview={onPreview}
                  onDownload={onDownload}
                  deleteable={false}
                />
              </div>
            )}
          </Col>
        </Row>

        {formSchema.comments?.map((item, index) => {
          return (
            <Row style={{ marginTop: 10 }}>
              <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                {item?.actor}
              </Col>
              <Col lg={18} md={18} sm={24} xs={24}>
                {/* {`  :  ${item?.selected || ''}`} */}
                <p dangerouslySetInnerHTML={{ __html: item.selected }} style={{ marginTop: -3 }} />
                {item?.comment && `: ${item?.comment || ''}`}
              </Col>
            </Row>
          )
        })}

        <hr />

        {!isViewMode && (
          <Row>
            <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {formSchema.approveOption?.label}
            </Col>
            <Col lg={18} md={18} sm={24} xs={24}>
              <>
                <ErrorMessage error={errors[formSchema.approveOption?.name]} />
                <Controller
                  name={formSchema.approveOption?.name}
                  control={control}
                  defaultValue={formSchema.approveOption?.value || null}
                  rules={isValidators(formSchema.approveOption?.validators)}
                  render={(props) => {
                    return (
                      <RadioGroup
                        disabled={formSchema.approveOption?.disabled}
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                          setCheckRadioDirector(value)
                        }}
                      >
                        {formSchema.approveOption?.options.map((item, index) => {
                          let color = '',
                            _className = ''
                          switch (index) {
                            case 0:
                              color = '#70b144'
                              _className = 'mod1rs-icon-size-lg'
                              break
                            case 1:
                              color = '#ffbd09'
                              _className = 'mod2rs-icon-size-lg'
                              break
                            default:
                              break
                          }
                          return (
                            <>
                              <div className={_className}>
                                <Radio
                                  key={item.value}
                                  value={item.value}
                                  disabled={formSchema.approveOption?.disabled || false}
                                >
                                  <p
                                    dangerouslySetInnerHTML={{ __html: item.label }}
                                    style={{ marginTop: -3 }}
                                  />
                                </Radio>
                              </div>
                            </>
                          )
                        })}
                      </RadioGroup>
                    )
                  }}
                />
              </>
            </Col>
          </Row>
        )}
        {/* {checkRadioDirector == 2 && (
          <Row>
            <Col lg={5} md={5} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
            <Col lg={19} md={19} sm={24} xs={24}>
              <>
                <ErrorMessage error={errors[formSchema.coordinatorOption.name]} />

                <Controller
                  key={formSchema.coordinatorOption.name}
                  name={formSchema.coordinatorOption.name}
                  control={control}
                  // rules={isValidators(formSchema.coordinatorOption.validators)}
                  //defaultValue={formSchema.coordinatorOption.value || null}
                  render={(props) => {
                    return (
                      <CheckboxGroup
                        name={formSchema.coordinatorOption.name}
                        value={checkRadio}
                        onChange={(value) => {
                          props.onChange(value)
                          setCheckRadio(value)
                          if (value.length === 0) setValue(formSchema.coordinatorOption.name)
                        }}
                      >
                        {formSchema.coordinatorOption.options?.map((item, index) => {
                          return (
                            <Checkbox
                              key={item.value}
                              value={item.value}
                              // disabled={!disabledApproveOption}
                            >
                              <p
                                dangerouslySetInnerHTML={{ __html: item.label }}
                                style={{ marginTop: -3 }}
                              />
                            </Checkbox>
                          )
                        })}
                      </CheckboxGroup>
                    )
                  }}
                />
              </>
            </Col>
          </Row>
        )} */}
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={18} md={18} sm={24} xs={24}>
            <InputForm
              schema={formSchema?.approveComment}
              disabled={formSchema.approveComment?.disabled || false}
              value={formSchema?.name}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              hideLabel
              componentClass="textarea"
              placeholder={'ระบุความเห็นเพิ่มเติม'}
              rows={4}
            />
          </Col>
        </Row>
      </Panel>
    </>
  )
}
